export const Route = "https://lovebigdev.azurewebsites.net/admin";

//Development only
// export const Route = "https://localhost:44370";
